module.exports = __webpack_public_path__ + "img/1_026.6bae34c5.jpg";